import { Image, Space } from 'antd';
import styled from 'styled-components';
import { DrawerPage } from 'components/DrawerPage';
import { ChevronLeft, Close } from 'icons';
import { DEVICE } from 'constants/app/breakpoints';

export const CartDrawer = styled(DrawerPage)`
  &&& {
    .ant-drawer-content-wrapper {
      overflow: hidden;
      right: 14px;
      top: 20px;
      bottom: 20px;
      border-radius: 24px;

      @media screen and ${DEVICE.xl} {
        width: 100%;
        top: 0;
        bottom: 0;
        right: 0;
        border-radius: unset;
      }
    }
  }
`;

export const CartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
  background: var(--v3-black-0);
  border: 1px solid var(--v3-black-2);
  box-shadow: 0 16px 33px rgba(119, 110, 171, 0.11);
`;

export const CartContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: var(--v3-black-0);
  overflow: auto;
`;

export const CloseIcon = styled(Close)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--v3-black-1);

  &:hover {
    background: unset;
  }
`;

export const BackIcon = styled(ChevronLeft)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--v3-black-1);

  &:hover {
    background: unset;
  }
`;

export const CartHeaderNavigation = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--v3-black-0);
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--v3-black-2);
`;

export const NotificationBody = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  align-self: stretch;
`;

export const NotificationImage = styled(Image)`
  &&& {
    width: 76px;
    height: 76px;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const NotificationTitle = styled.h4`
  color: var(--v3-primary-color);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.36px;
`;
export const NotificationDescription = styled.p`
  margin-bottom: 0px;
  color: var(--v3-text-color);
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.3px;
`;
export const NotificationAction = styled.strong`
  color: var(--v3-text-color);
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.3px;
  text-decoration-line: underline;
  cursor: pointer;
  padding-left: 8px;
`;
export const NotificationCloseButton = styled(Space)`
  &&& {
    background: var(--v3-black-1);
    width: 30px;
    height: 30px;
    font-size: 20px;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
  }
`;

export const NotificationCloseIcon = styled(Close)`
  display: flex;
  align-items: center;
`;
